import { toast } from 'sonner';
import { getEdgeFunctionErrorMessage } from './edgeFunction';

/**
 * Shows a toast error with the edge function name included
 */
export function toastEdgeFunctionError(
  functionName: string, 
  error: any, 
  prefix?: string
): string {
  const message = getEdgeFunctionErrorMessage(error, functionName);
  
  // The message is now already clean (no prefix), use it directly
  const isGeneric = message === 'An unexpected error occurred. Please try again.' || !message;
  const fullMessage = prefix && isGeneric ? `${prefix}. Please try again.` : message;
  
  toast.error(fullMessage);
  return message;
}